export default __webpack_public_path__ + "f04ae19676ac49e20b64d5477050123a.svg";